import { RadioButtonWithLabelOption, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FormikRadioButtonGroup } from '~commonInfra/components/FormikRadioButtonGroup';
import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle, settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const SENSITIVE_LINEAGE_DATA_SECTION_TEST_ID = 'catalog-obfuscation-site-setting';
export const SENSITIVE_LINEAGE_DATA_LEARN_MORE_TEST_ID = 'catalog-obfuscation-learn-more-link';
export const SENSITIVE_LINEAGE_DATA_ENABLED_BUTTON_TEST_ID = 'obfuscation-complete-lineage-radio-button';
export const SENSITIVE_LINEAGE_DATA_DISABLED_BUTTON_TEST_ID = 'obfuscation-partial-lineage-radio-button';

export type SensitiveLineageDataSectionProps = SiteSettingsForSiteAdminProps<'catalogObfuscationEnabled'>;

export function SensitiveLineageDataSection() {
  const buttonList = React.useMemo(() => getButtonList(), []);
  return (
    <SettingsSection
      title={Messages.catalogObfuscationSettingsHeader()}
      description={getDescription()}
      testId={SENSITIVE_LINEAGE_DATA_SECTION_TEST_ID}
    >
      <FormikRadioButtonGroup
        aria-label={Messages.catalogObfuscationSettingsHeader()}
        buttonList={buttonList}
        className={settingsRadioButtonItemHeight}
        name={'settings.catalogObfuscationEnabled'}
      />
    </SettingsSection>
  );
}

function getDescription() {
  return (
    <span>
      {Messages.catalogObfuscationSettingDetails()}
      <TextLinkWidget
        className={learnMoreStyle}
        href={HelpService.getServerHelpUrlByCategory('dm-obfuscation')}
        target='_blank'
        testId={SENSITIVE_LINEAGE_DATA_LEARN_MORE_TEST_ID}
      >
        {Messages.catalogObfuscationLearnMore()}
      </TextLinkWidget>
    </span>
  );
}

function getButtonList(): RadioButtonWithLabelOption<boolean>[] {
  const sensitiveLineageDataEnabledButtonLabel = <>
    <div>{Messages.catalogObfuscationCompleteLineageLabel()}</div>
    <div>{Messages.catalogObfuscationCompleteLineageDescription()}</div>
  </>;
  const sensitiveLineageDataDisabledButtonLabel = <>
    <div>{Messages.catalogObfuscationPartialLineageLabel()}</div>
    <div>{Messages.catalogObfuscationPartialLineageDescription()}</div>
  </>;

  return [
    {
      value: true,
      label: sensitiveLineageDataEnabledButtonLabel,
      testId: SENSITIVE_LINEAGE_DATA_ENABLED_BUTTON_TEST_ID
    },
    {
      value: false,
      label: sensitiveLineageDataDisabledButtonLabel,
      testId: SENSITIVE_LINEAGE_DATA_DISABLED_BUTTON_TEST_ID
    }
  ];
}

/* for registering the component in settings registry */
export const SensitiveLineageDataSectionSpecs = componentRegistryEntry({
  name: 'SensitiveLineageDataSection',
  component: SensitiveLineageDataSection
});
